import { jwtDecode } from "jwt-decode";
import { TokenResponse } from "../types/auth";

const TOKEN_KEY = "@TactImobi:token";

export const tokenService = {
  saveToken(token: TokenResponse): void {
    localStorage.setItem(TOKEN_KEY, JSON.stringify(token));
  },

  setToken(token: TokenResponse): void {
    this.saveToken(token);
  },

  getToken(): TokenResponse | null {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      try {
        return JSON.parse(token) as TokenResponse;
      } catch {
        return null;
      }
    }
    return null;
  },

  removeToken(): void {
    localStorage.removeItem(TOKEN_KEY);
  },

  hasToken(): boolean {
    return !!this.getToken();
  },

  isTokenExpired(): boolean {
    const token = this.getToken();
    if (!token?.access) {
      return true; // Se não há token, consideramos expirado
    }

    try {
      const decodedToken = jwtDecode<{ exp: number }>(token.access);
      if (!decodedToken.exp) {
        return true; // Se não há data de expiração, consideramos inválido/expirado
      }

      const currentTime = Date.now() / 1000; // Tempo atual em segundos
      return decodedToken.exp < currentTime;
    } catch (error) {
      console.error("Erro ao decodificar o token:", error);
      return true; // Em caso de erro na decodificação, consideramos expirado
    }
  },
};